import sessionHelperInstance from "./sessionHelper";
import { Client } from "./_clientService";

const executeRequest = async (options: any) => {
  try {
    const resp = await new Client(options)[options.method]();
    return resp;
  } catch (error) {
    throw error;
  }
};

export async function removeBotAndGhostTeams(type: any, age?: any) {
  if (!type) throw new Error("No type provided");

  return executeRequest({
    method: "post",
    path: `/botGhostManage/remove`,
    payload: { type, age },
  });
}

export async function uploadBulkTeams(file: any) {
  try {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${sessionHelperInstance?.token}`);

    const formData = new FormData();
    formData.append("file", file);

    const req: RequestInit = {
      method: "POST",
      headers: myHeaders,
      body: formData,
      redirect: "follow" as RequestRedirect,
    };
    let url = `${import.meta.env.VITE_CMS_API_URL}/botGhostManage/bulkCreate`;
    const response = await fetch(url, req);

    return await response.json();
  } catch (error) {
    throw error;
  }
}
